import { motion } from "motion/react";
import React from "react";

import AccountingData from "../components/accounting-data";
import settings from "../settings";

const AccountingDataPage = () => {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={settings.routeAnimation.pageVariants}
      transition={settings.routeAnimation.pageTransition}
    >
      <AccountingData />
    </motion.div>
  );
};

export default AccountingDataPage;
